export const TELEMETRY_CARD_GROUPS = ['primary', 'performance', 'energy', 'alerts', 'diagnostics'];

export const TELEMETRY_CARD_CONFIG = [
  {
    code: 'kmh',
    group: 'primary',
    order: 10,
    labelKey: 'Speed',
    icon: 'ActivityIcon',
    unitLabel: 'Km/h',
    color: 'info',
  },
  {
    code: 'hor',
    group: 'primary',
    order: 20,
    labelKey: 'Hourmeter',
    icon: 'ClockIcon',
    unitLabel: 'Hours',
    color: 'info',
  },
  {
    code: 'hrb',
    group: 'primary',
    order: 30,
    labelKey: 'Hourmeter B',
    icon: 'ClockIcon',
    unitLabel: 'Hours',
    color: 'info',
  },
  {
    code: 'hod',
    group: 'primary',
    order: 40,
    labelKey: 'Odometer',
    icon: 'AirplayIcon',
    unitLabel: 'Km',
    color: 'info',
  },
  {
    code: 'cbc',
    group: 'primary',
    order: 50,
    labelKey: 'Consumption',
    icon: 'DropletIcon',
    unitLabel: 'L/h',
    color: 'info',
    decimals: 1,
  },
  {
    code: 'tpa',
    group: 'primary',
    order: 60,
    labelKey: 'Engine',
    icon: 'ThermometerIcon',
    unitLabel: 'ºC',
    color: 'info',
  },
  {
    code: 'tda',
    group: 'primary',
    order: 62,
    labelKey: 'Air Discharge Temperature',
    icon: 'ThermometerIcon',
    unitLabel: 'ºC',
    color: 'info',
  },
  {
    code: 'pda',
    group: 'primary',
    order: 64,
    labelKey: 'Air Discharge Pressure',
    icon: 'InfoIcon',
    unitLabel: 'psi',
    color: 'info',
  },
  {
    code: 'tpt',
    group: 'primary',
    order: 70,
    labelKey: 'Transmission',
    icon: 'ThermometerIcon',
    unitLabel: 'ºC',
    color: 'info',
  },
  {
    code: 'toh',
    group: 'primary',
    order: 80,
    labelKey: 'Hydraulic oil',
    icon: 'ThermometerIcon',
    unitLabel: 'ºC',
    color: 'info',
  },
  {
    code: 'rpm',
    group: 'primary',
    order: 90,
    labelKey: 'RPM',
    icon: 'RotateCwIcon',
    unitLabel: 'r/min',
    color: 'info',
  },
  {
    code: 'cgm',
    group: 'primary',
    order: 100,
    labelKey: 'Engine Load',
    icon: 'ZapIcon',
    unitLabel: '%',
    color: 'info',
  },
  {
    code: 'mta',
    group: 'performance',
    order: 110,
    labelKey: 'Max Temp Engine',
    icon: 'ThermometerIcon',
    unitLabel: 'ºC',
    color: 'info',
  },
  {
    code: 'mcc',
    group: 'performance',
    order: 120,
    labelKey: 'Max Consumption',
    icon: 'DropletIcon',
    unitLabel: 'L/h',
    color: 'info',
  },
  {
    code: 'mth',
    group: 'performance',
    order: 130,
    labelKey: 'Max Temp Hydraulic oil',
    icon: 'ThermometerIcon',
    unitLabel: 'ºC',
    color: 'info',
  },
  {
    code: 'mtt',
    group: 'performance',
    order: 140,
    labelKey: 'Max Temp Transmission',
    icon: 'ThermometerIcon',
    unitLabel: 'ºC',
    color: 'info',
  },
  {
    code: 'pcb',
    group: 'performance',
    order: 150,
    labelKey: 'Fuel Pressure',
    icon: 'InfoIcon',
    unitLabel: 'kPa',
    color: 'info',
  },
  {
    code: 'pom',
    group: 'performance',
    order: 160,
    labelKey: 'Engine Oil Pressure',
    icon: 'InfoIcon',
    unitLabel: 'kPa',
    color: 'info',
  },
  {
    code: 'ptb',
    group: 'performance',
    order: 170,
    labelKey: 'Turbo Pressure',
    icon: 'InfoIcon',
    unitLabel: 'kPa',
    color: 'info',
  },
  {
    code: 'tbt',
    group: 'performance',
    order: 180,
    labelKey: 'Battery Voltage',
    icon: 'InfoIcon',
    unitLabel: 'Volts',
    color: 'info',
  },
  {
    code: 'acl',
    group: 'performance',
    order: 190,
    labelKey: 'Acceleration',
    icon: 'InfoIcon',
    unitLabel: 'G',
    color: 'info',
    decimals: 2,
  },
  {
    code: 'soc',
    group: 'energy',
    order: 200,
    labelKey: 'Power Battery Charge',
    icon: 'InfoIcon',
    unitLabel: '%',
    color: 'info',
  },
  {
    code: 'soh',
    group: 'energy',
    order: 210,
    labelKey: 'Power Battery Life',
    icon: 'InfoIcon',
    unitLabel: '%',
    color: 'info',
  },
  {
    code: 'ttb',
    group: 'energy',
    order: 220,
    labelKey: 'Power Battery Volts',
    icon: 'InfoIcon',
    unitLabel: 'Volts',
    color: 'info',
  },
  {
    code: 'tpb',
    group: 'energy',
    order: 230,
    labelKey: 'Power Battery Temperature',
    icon: 'InfoIcon',
    unitLabel: 'ºC',
    color: 'info',
  },
  {
    code: 'tom',
    group: 'performance',
    order: 240,
    labelKey: 'Engine oil temperature',
    icon: 'ThermometerIcon',
    unitLabel: 'ºC',
    color: 'info',
  },
  {
    code: 'ctr',
    group: 'diagnostics',
    order: 250,
    labelKey: 'Counter',
    icon: 'InfoIcon',
    unitLabel: 'Pulses',
    color: 'info',
  },
  {
    code: 'btf',
    group: 'alerts',
    order: 260,
    labelKey: 'Battery',
    icon: 'BatteryChargingIcon',
    unitLabel: '⚠️',
    color: 'warning',
    valueLabelKey: 'Low Battery',
  },
  {
    code: 'cbt',
    group: 'energy',
    order: 270,
    labelKey: 'Fuel',
    component: 'gauge',
  },
  {
    code: 'tct',
    group: 'diagnostics',
    order: 280,
    labelKey: 'Active failure',
    icon: 'InfoIcon',
    color: 'info',
    hideValue: true,
  },
  {
    code: 'bus',
    group: 'diagnostics',
    order: 320,
    labelKey: 'Compass Heading',
    icon: 'CompassIcon',
    unitLabel: '°',
    color: 'info',
  },
  {
    code: 'prh',
    group: 'performance',
    order: 360,
    labelKey: 'Hydraulic Pressure',
    icon: 'TargetIcon',
    unitLabel: 'kPa',
    color: 'info',
  },
  {
    code: 'acx',
    group: 'performance',
    order: 380,
    labelKey: 'Acceleration X',
    icon: 'TrendingUpIcon',
    unitLabel: 'm/s²',
    color: 'info',
    decimals: 2,
  },
  {
    code: 'acy',
    group: 'performance',
    order: 390,
    labelKey: 'Acceleration Y',
    icon: 'TrendingUpIcon',
    unitLabel: 'm/s²',
    color: 'info',
    decimals: 2,
  },
  {
    code: 'acz',
    group: 'performance',
    order: 400,
    labelKey: 'Acceleration Z',
    icon: 'TrendingUpIcon',
    unitLabel: 'm/s²',
    color: 'info',
    decimals: 2,
  },
  {
    code: 'ilt',
    group: 'performance',
    order: 420,
    labelKey: 'Inclination Angle',
    icon: 'ArrowUpRightIcon',
    unitLabel: '°',
    color: 'info',
  },
  {
    code: 'vvt',
    group: 'performance',
    order: 430,
    labelKey: 'Wind speed',
    icon: 'WindIcon',
    unitLabel: 'm/s',
    color: 'info',
  },
  {
    code: 'cpl',
    group: 'performance',
    order: 440,
    labelKey: 'Crane Boom Length',
    icon: 'Maximize2Icon',
    unitLabel: 'm',
    color: 'info',
  },
  {
    code: 'agl',
    group: 'performance',
    order: 450,
    labelKey: 'Crane Boom Angle',
    icon: 'CompassIcon',
    unitLabel: '°',
    color: 'info',
  },
  {
    code: 'ral',
    group: 'performance',
    order: 460,
    labelKey: 'Crane Working Radius',
    icon: 'TargetIcon',
    unitLabel: 'm',
    color: 'info',
  },
  {
    code: 'cag',
    group: 'performance',
    order: 470,
    labelKey: 'Crane Actual Load',
    icon: 'PackageIcon',
    unitLabel: 'Kg',
    color: 'info',
  },
  {
    code: 'cng',
    group: 'performance',
    order: 480,
    labelKey: 'Crane Rated Capacity',
    icon: 'PackageIcon',
    unitLabel: 'Kg',
    color: 'info',
  },
  {
    code: 'pcg',
    group: 'performance',
    order: 490,
    labelKey: 'Crane Load Percentage',
    icon: 'PercentIcon',
    unitLabel: '%',
    color: 'info',
  },
  {
    code: 'alg',
    group: 'performance',
    order: 500,
    labelKey: 'Crane Boom Tip Height',
    icon: 'ArrowUpIcon',
    unitLabel: 'm',
    color: 'info',
  },
  {
    code: 'arg',
    group: 'performance',
    order: 510,
    labelKey: 'Crane Slew Angle',
    icon: 'RotateCwIcon',
    unitLabel: '°',
    color: 'info',
  },
  {
    code: 'icg',
    group: 'performance',
    order: 520,
    labelKey: 'Crane Machine Inclination',
    icon: 'TrendingUpIcon',
    unitLabel: '°',
    color: 'info',
  },
];

